import * as React from 'react';
import { useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import selectors from '../CheckOutSummary/selectors';
import actions from './actions';

type QueryStringParams = {
  co: string;
  id: string;
};

const GetDetailsFromRoute = () => {
  const location = useLocation();
  const checkOut = useSelector(selectors.selectCheckOut);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (location.pathname === '/checkout' && location.search && !checkOut) {
      const params = queryString.parse(location.search) as QueryStringParams;

      if (params && params.co) {
        dispatch(actions.setCheckOutDataFromQueryString(params.co));
      }
    } else if (location.pathname.includes('account-link-intent') && location.search) {
      const params = queryString.parse(location.search) as QueryStringParams;
      if (params && params.id) {
        dispatch(actions.setIntentIdFromRoute(params.id));
      }
    } else {
      dispatch(actions.setCheckOutDataFromQueryString(''));
    }
  }, []);

  return null;
};

export default GetDetailsFromRoute;
